const t = {
  name: "HeartHealth",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.9 38.2" style="enable-background:new 0 0 39.9 38.2;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,13h2v5h5v2h-5v5h-2v-5h-5v-2h5V13z"/>
		<path class="st0" d="M29.5,0c2.9,0.1,5.6,1.4,7.6,3.7h0c2.1,2.4,3.1,5.6,2.9,8.8c-1.2,14-18.6,24.9-19.4,25.3l0,0L20,38.2
			l-0.5-0.3C18.7,37.4,1.3,26.5,0,12.5c-0.3-3.2,0.8-6.4,2.9-8.8c2-2.2,4.6-3.5,7.6-3.7c3.8-0.2,7.4,1.6,9.5,4.7
			C22.1,1.6,25.7-0.2,29.5,0z M20,35.8c2.9-1.9,16.9-11.7,17.9-23.5l0,0C38.2,9.7,37.3,7,35.6,5c-1.6-1.8-3.8-2.9-6.2-3
			c-3.6-0.2-6.9,1.8-8.5,5.1L20,9l-0.9-1.9C17.6,4,14.4,2,11,2h-0.4C8.2,2.1,6,3.2,4.4,5C2.7,7,1.8,9.7,2,12.3
			C3.1,24.1,17.1,33.9,20,35.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as HeartHealth
};
